import {
	ModalBoxLogin,
	ModalBoxRegister,
	ModalBoxForget,
	ModalBoxPassword
} from 'Elements';

export const useAuthModal = (modalName) => {
	const modals = {
		login: ModalBoxLogin,
		register: ModalBoxRegister,
		forget: ModalBoxForget,
		password: ModalBoxPassword
	};
	return modals[modalName.toString()];
};
